/** Read a boolean from API payloads that may use bool, 0/1, or string forms. */
export function pickBool(
  source: Record<string, unknown> | null | undefined,
  ...keys: string[]
): boolean {
  if (!source) return false;
  for (const key of keys) {
    const value = source[key];
    if (typeof value === 'boolean') return value;
    if (value === 'true' || value === 1) return true;
    if (value === 'false' || value === 0) return false;
  }
  return false;
}

export function pickNumber(
  source: Record<string, unknown> | null | undefined,
  ...keys: string[]
): number | undefined {
  if (!source) return undefined;
  for (const key of keys) {
    const value = source[key];
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    if (typeof value === 'string' && value.trim() !== '') {
      const parsed = Number(value);
      if (Number.isFinite(parsed)) return parsed;
    }
  }
  return undefined;
}
